import { AlignerService } from './services/aligner.service';
import { BrowserModule } from '@angular/platform-browser'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HttpClientModule } from '@angular/common/http'
import { AppComponent } from './app.component'
import { LoginComponent } from './login/login.component'
import { AppRoutingModule } from './app-routing.module'
import { TopComponent } from './app_manager/top/top.component'
import {
    AppConfigService,
    AuthGuard,
    AuthService,
    ChatService,
    ClientGuard,
    NotificationService,
    PendingChangesGuard,
    RequestServices,
    RestServices,
    SocketService,
    StateServices,
} from './services'
import { PromotionModule } from './promotion/promotion.module'
import { AppElementModule } from './app_manager/app_element/appElement.module'
import { ScrollbarModule } from 'ngx-scrollbar'
import { ClientModule } from './app_manager/app_element/client/client.module'
import { StatusModule } from './app_manager/app_element/status/status.module'
import { SettingModule } from './app_manager/app_element/setting/setting.module'
import { ClientDetailModule } from './app_manager/app_element/client-detail/client-detail.module'
import { OnsenModule } from 'ngx-onsenui'
import { CommunicationModule } from './app_manager/app_element/communication/communication.module'
import { CookieService } from 'ngx-cookie-service'
import { CommunicationRoomModule } from './app_manager/app_element/communication-room/communication-room.module'
import { ClientAppModule } from './client-app/client-app.module'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NvD3Module } from 'ng2-nvd3'
import { AvailabilityGuard } from './services/guarad/availability.guard'
import { PipeModule } from './pipes/pipe.module'
import { ModalCommonsModule } from '@modal/modal-commons/modal-commons.module'
import { CommonsModule } from '@commons/commons.module'
import { ToastrModule } from 'ngx-toastr'
import { SharedModule } from '@app/shared/shared.module'
import { MailService } from './services/mail.service'
import { AppUtilService } from './shared/utils/app-util.service'

const DECLARES = []

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        TopComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        HttpClientModule,
        PromotionModule,
        ClientModule,
        StatusModule,
        SettingModule,
        CommunicationModule,
        ScrollbarModule,
        OnsenModule,
        AppElementModule,
        CommunicationRoomModule,
        ClientDetailModule,
        BrowserAnimationsModule,
        ClientAppModule,
        NvD3Module,
        ReactiveFormsModule,
        PipeModule,
        SharedModule,
        ...DECLARES,
        ModalCommonsModule,
        ToastrModule.forRoot(),
        CommonsModule,
    ],
    providers: [
        AppConfigService,
        AuthService,
        AuthGuard,
        AvailabilityGuard,
        ClientGuard,
        RestServices,
        MailService,
        AlignerService,
        AppUtilService,
        RequestServices,
        PendingChangesGuard,
        NotificationService,
        CookieService,
        StateServices,
        ChatService,
        SocketService
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    exports: [],
    bootstrap: [AppComponent],
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts